import { Component, OnInit, Output, EventEmitter, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'gaweb-counter',
    templateUrl: './counter.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CounterComponent),
            multi: true
        }
    ]
})
export class CounterComponent implements OnInit, ControlValueAccessor {
    @Output() onCounterUpdated: EventEmitter<any> = new EventEmitter();


    private _initialValue: number;

    @Input('initialValue')
    get initialValue() {
        return this._initialValue;
    }
    set initialValue(val: number) {
        this._initialValue = val;
        this.value = !!val ? val : 0;
    }
    @Input() min: number;
    @Input() max: number;
    private  _value: number;
    get value() {
        return this._value;
    }
    @Input('value')
    set value(val: number) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }
    minReached = false;
    maxReached = false;
    onChange: any = () => { };
    onTouched: any = () => { };
    constructor() { }

    ngOnInit() {
    }

    increment() {
        if (this.value < this.max) {
            this.value += 1;
            this.maxReached = false;
        }
        this.onCounterUpdated.emit(this.value);
    }

    decrement() {
        if (this.value > this.min) {
            this.value -= 1;
            this.minReached = false;
        }
        this.onCounterUpdated.emit(this.value);
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    writeValue(value) {
        if (value !== undefined && value !== null) {
            this.value = value;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/counter/counter.component.ts